import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';

export default class UploadedPost extends EventPost {
    icon() {
        return 'far fa-images';
    }

    description(data: any) {
        const renamed = app.translator.trans('kilowhat-cimaise.forum.post-stream.uploaded', data);

        return m('span', renamed);
    }

    descriptionData() {
        const post = this.attrs.post;

        return {
            ...(post.content() as {} || {}),
            user: post.user(),
        };
    }
}
